import get from "lodash/get";

export const getManifestTrackingParams = ({
  manifest,
  application,
  tracking
}) => {
  const layout = get(manifest, "data.config.pricing.layout") || [];
  const result = {
    ...tracking,
    manifest_id: manifest.id,
    merchant_account_id: application.merchant_account_id,
    application_id: application.id,
    subdomain: application.subdomain,
    product_count: layout.length
  };

  return result;
};
